import { useUploadStore } from '../../../../store/uploadStore';
import { stylesheet } from 'typestyle';
import { typeCompact12MediumProperties, White } from '@traceair/tds';
import { DroneQIcon } from '@traceair/webapp-icons';
import React from 'react';
import { GlobalUploadValidation } from './GlobalUploadValidation';
import { GlobalStatusInterrupted } from './GlobalStatusInterrupted';
import { GlobalUploadCount } from './GlobalUploadCount';
import { GlobalUploadRemainingTime } from './GlobalUploadRemainingTime';
import { GlobalUploadProgress } from './GlobalUploadProgress';
import { getInterruptedUploads } from './getInterruptedUploads';
import { isUploadCompleted } from '../helpers/completion';
import { getGlobalValidationStatus } from './getGlobalValidationStatus';

const css = stylesheet({
  container: {
    margin: '0 12px',
    padding: 12,
    boxShadow: '0px 3px 12px 0px rgba(0, 0, 0, 0.05)',
    borderRadius: 16,
    background: White,
    ...typeCompact12MediumProperties,
  },
  icon: {
    marginBottom: 8,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '8px 0 8px',
  },
});

export const GlobalUploadState = () => {
  const { uploads, getRegistrationRequests } = useUploadStore();

  const currentUploads = Object.values(uploads).filter((upload) => !upload.meta.isPreviouslyCompleted);
  if (!Object.values(currentUploads).length) {
    return null;
  }

  const interruptedUploads = getInterruptedUploads(currentUploads, getRegistrationRequests);
  const globalValidationStatus = getGlobalValidationStatus(currentUploads);
  const isCompleted = currentUploads.reduce((acc, upload) => acc && isUploadCompleted(upload), true);

  return (
    <div className={css.container}>
      <div className={css.icon}>
        <DroneQIcon size={24} />
      </div>

      {interruptedUploads.length ? (
        <GlobalStatusInterrupted interruptedUploads={interruptedUploads} />
      ) : (
        <>
          <div className={css.header}>
            <div>Uploads</div>

            <GlobalUploadCount currentUploads={currentUploads} />
          </div>

          <GlobalUploadProgress
            currentUploads={currentUploads}
            globalValidationStatus={globalValidationStatus}
            isCompleted={isCompleted}
          />

          {!isCompleted && <GlobalUploadRemainingTime currentUploads={currentUploads} />}

          <GlobalUploadValidation globalValidationStatus={globalValidationStatus} />
        </>
      )}
    </div>
  );
};
